import { useState, useEffect } from 'react';
import styles from "@/components/directory/v2/DisplayManager.module.css";
import { FaList, FaTh } from 'react-icons/fa';

const DisplayManager = ({ onDisplayChange }) => {
  const [selectedButton, setSelectedButton] = useState('');

  useEffect(() => {
    if (typeof window !== 'undefined') {
      const storedButton = localStorage.getItem('selectedDisplay') || 'list';
      setSelectedButton(storedButton.toLowerCase());
    }
  }, []);

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('selectedDisplay', selectedButton.toLowerCase());
    }
    onDisplayChange(selectedButton);
  }, [selectedButton, onDisplayChange]);

  const handleClick = (buttonName) => {
    setSelectedButton(buttonName);
  };

  return (
    <div className={styles.container}>
      <div className={styles.buttonGroup}>
        <div
          className={selectedButton === 'list' ? styles.buttonSelected : styles.button}
          onClick={() => handleClick('list')}
        >
          <FaList />
        </div>
        <div
          className={selectedButton === 'grid' ? styles.buttonSelected : styles.button}
          onClick={() => handleClick('grid')}
        >
          <FaTh />
        </div>
      </div>
    </div>
  );
}

export default DisplayManager;
